import type { WorkspaceMembersResult } from '@cbhq/identity-api-hooks/account-management/fetch';

import { isValidEmail } from '../../../utils/stringUtils';

export type InviteEmailErrorKind =
  | 'required'
  | 'invalid'
  | 'selfInvite'
  | 'alreadyMember'
  | 'alreadyInvited'
  | null;

type ValidateInviteEmailParams = {
  email: string;
  currentUserEmail?: string;
  members?: WorkspaceMembersResult['members'];
  pendingInvites?: WorkspaceMembersResult['pendingInvites'];
};

export function validateInviteEmail({
  email,
  currentUserEmail,
  members,
  pendingInvites,
}: ValidateInviteEmailParams): InviteEmailErrorKind {
  const trimmed = email.trim();
  if (!trimmed) {
    return 'required';
  }
  if (!isValidEmail(trimmed)) {
    return 'invalid';
  }

  const normalized = trimmed.toLowerCase();
  if (currentUserEmail && currentUserEmail.toLowerCase() === normalized) {
    return 'selfInvite';
  }

  const isExistingMember = (members ?? []).some(
    (member) => member.email?.toLowerCase() === normalized,
  );
  if (isExistingMember) {
    return 'alreadyMember';
  }

  const isPendingInvite = (pendingInvites ?? []).some(
    (invite) => invite.email?.toLowerCase() === normalized,
  );
  if (isPendingInvite) {
    return 'alreadyInvited';
  }

  return null;
}
